import React from "react"
import { Card, Row, Col, Alert, Form } from "antd"
import { Typography } from "antd"
import { type ReservationData } from "services/proposal"

const { Text } = Typography

type InvoiceReservedStepProps = {
  form: any
  reservationData: ReservationData | null
  authBrand: string
  isLoadingAuth: boolean
  isInspect: boolean
}

const InvoiceReservedStep: React.FC<InvoiceReservedStepProps> = ({
  form,
  reservationData,
  authBrand,
  isLoadingAuth,
  isInspect
}) => {
  const codeMarqueValue = Form.useWatch("codeMarque", form)

  return (
    <Card title="VIN Réservé - Données de réservation" className="wizard-step-card">
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Alert
            message="VIN Réservé"
            description="Ce VIN est déjà réservé dans le système. Les données ci-dessous sont préremplies depuis la réservation."
            type="success"
            showIcon
            style={{ marginBottom: 24 }}
          />
        </Col>
      </Row>

      {reservationData && (
        <>
          <Row gutter={[24, 16]} style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <Text type="secondary" style={{ fontSize: '12px' }}>CODE CLIENT</Text>
              <div style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '4px',
                fontWeight: '500'
              }}>
                {(reservationData as any).clientreference || (reservationData as any).clientCode || 'N/A'}
              </div>
            </Col>
            
            <Col span={8}>
              <Text type="secondary" style={{ fontSize: '12px' }}>MARQUE</Text>
              <div style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '4px',
                fontWeight: '500'
              }}>
                {isLoadingAuth ? "Détection en cours..." : (authBrand || codeMarqueValue || (reservationData as any).codeMarque || 'À déterminer')}
              </div>
            </Col>
            
            <Col span={8}>
              <Text type="secondary" style={{ fontSize: '12px' }}>FAMILLE PRODUIT</Text>
              <div style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '4px',
                fontWeight: '500'
              }}>
                {form.getFieldValue("familyLabel") || (reservationData as any).prcode || (reservationData as any).productFamily || 'N/A'}
              </div>
            </Col>
          </Row>

          <Row gutter={[24, 16]} style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <Text type="secondary" style={{ fontSize: '12px' }}>VIN COMPLET</Text>
              <div style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '4px',
                fontFamily: 'monospace',
                fontSize: '13px',
                fontWeight: '500'
              }}>
                {(reservationData as any).vin1 && (reservationData as any).vin2 
                  ? `${(reservationData as any).vin1}${(reservationData as any).vin2}` 
                  : (reservationData as any).vin || (reservationData as any).vin1 || 'N/A'}
              </div>
            </Col>
            
            <Col span={8}>
              <Text type="secondary" style={{ fontSize: '12px' }}>MONTANT</Text>
              <div style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '4px',
                fontWeight: 'bold',
                fontSize: '16px'
              }}>
                {((reservationData as any).ctfinancedamount || (reservationData as any).reservationAmount || 0).toLocaleString('fr-FR')}€
              </div>
            </Col>
            
            <Col span={8}>
              <Text type="secondary" style={{ fontSize: '12px' }}>N° RÉSERVATION</Text>
              <div style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '4px',
                fontWeight: '500'
              }}>
                {(reservationData as any).propreference || (reservationData as any).ctreference || 'N/A'}
              </div>
            </Col>
          </Row>

          <Row gutter={[24, 16]}>
            <Col span={24}>
              <Alert
                message="Étape suivante"
                description="Vous pouvez maintenant passer à la création de la facture avec ces données pré-remplies."
                type="info"
                showIcon
              />
            </Col>
          </Row>
        </>
      )}
    </Card>
  )
}

export default InvoiceReservedStep